// Bundle entry point for the ticket checkout module.
// Frappe's esbuild compiles all relative imports into a single hashed file,
// ensuring automatic cache-busting on every change.
import { initTicketsPage } from './event/tickets/tickets-init.js';

initTicketsPage();
